import { useState } from "react";
import { useT } from "../i18n";
import { betragFehler, betragFehlerNummernfeld, betragNummernwert } from "../daten/zahlfeld";

/* ══════════════════════════════════════════════════════════════════
   Der Satz unter einem Betragsfeld, das nichts schicken kann.

   Nachprüfung Runde 4 (04.10.2026): Aus getippten „65" wurden im Satzfeld
   der Anlieferung „6,00" (N4-01), aus „12,345" im Einzel-Feld still 12,34
   (N4-06). Seitdem bleibt der Text im Feld, wie er getippt ist, und was
   nicht passt, steht hier als Satz — die Kante allein sagt nichts.
   ══════════════════════════════════════════════════════════════════ */

export function Betragssatz({ text, nummernfeld = false }: {
  text: string;
  /** Das Feld ist ein `<input type="number">` — Punkt ist dort immer das Komma. */
  nummernfeld?: boolean;
}) {
  const t = useT();
  const fehler = nummernfeld ? betragFehlerNummernfeld(text) : betragFehler(text);
  if (fehler === null) return null;
  return (
    <span className="betrag-satz" role="alert">
      {t(fehler === "drei_stellen" ? "zahlfeld.dreiStellen" : "zahlfeld.unlesbar", { wert: text.trim() })}
    </span>
  );
}

/**
 * **Ein Betrag in einem `<input type="number">` steht mit zwei Stellen da,
 * solange niemand darin tippt** (N6-01, 04.10.2026).
 *
 * Die Felder des Preisstamms (Leistungen, Zuschläge) halten ihren Text im
 * Zustand und vergleichen ihn mit dem gespeicherten, um „geändert" zu
 * erkennen. Darum wird hier nur die **Anzeige** geformt — „65" steht als
 * 65,00 da, im Feld wird weiter getippt, was getippt ist —, statt jeden
 * Zustand und jeden Vergleich umzuschreiben. Gerechnet wird mit
 * `betragNummernwert`, demselben Baustein wie in jedem Textfeld.
 *
 * `aktiv` ist aus, wo dasselbe Feld einen Prozentsatz trägt.
 */
export function useBetragsnummer(wert: string, aktiv = true) {
  const [drin, setzeDrin] = useState(false);
  return {
    value: aktiv && !drin ? betragNummernwert(wert) : wert,
    onFocus: () => setzeDrin(true),
    onBlur: () => setzeDrin(false),
  };
}
